import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const DownChevronComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__downChevron"
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path d="M4.5 6L8.5 10L12.5 6" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const DownChevron = withIcon(DownChevronComponent);
